import React from 'react';
import GGApi from '../../utils/GGApi.js';
import { logGgPlusManageClicked } from '../../utils/ggPlusAnalytics.js';
import './Gg_plus_shared.css';

/**
 * Undo a scheduled GG+ cancel (Stripe cancel_at_period_end).
 * Used on account hub card and membership manage page.
 */
function Gg_plus_reactivate_link({ label = 'Keep GG+', onSuccess, className = '', analyticsSource = 'membership_page' }) {
  const [loading, setLoading] = React.useState(false);

  const handleClick = () => {
    if (loading) return;
    logGgPlusManageClicked({ action: 'reactivate', source: analyticsSource });
    setLoading(true);

    GGApi.reactivate_membership()
      .then((response) => {
        if (response && response.success) {
          return GGApi.checkToken().then(() => {
            if (onSuccess) {
              onSuccess();
            } else {
              window.location.reload();
            }
          });
        }
        alert(response && response.message ? response.message : 'Something went wrong. Please try again.');
        setLoading(false);
      })
      .catch(() => {
        alert('Something went wrong. Please try again.');
        setLoading(false);
      });
  };

  return (
    <p
      className={`gg_plus_hub_link green_text${loading ? ' membership_cancel_link_disabled' : ''} ${className}`.trim()}
      onClick={loading ? undefined : handleClick}
    >
      {loading ? 'Saving…' : label}
    </p>
  );
}

export default Gg_plus_reactivate_link;
